// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 114 ? "vendor.reselect" : chunkId) + ".bundle.js";
};